import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-empty',
  templateUrl: './card-empty.component.html',
  styleUrls: ['./card-empty.component.scss'],
})
export class CardEmptyComponent {
  @Input() height = '500px';
  @Input() iconSize = '100';
  @Input() title = '';
  @Input() subtitle = '';
  @Input() iconClass = 'search';
  @Input() iconColor = 'u-clr-gray';
  @Input() iconSvg?: string;
  @Input() widthContainer = 'auto';
}
